export default __webpack_public_path__ + "static/media/4.0fb18209.jpg";